import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { INSTRUCTOR } from "@/data/content";
import { useEnroll } from "@/context/EnrollContext";

export const Instructor = () => {
  const { openEnroll } = useEnroll();
  return (
    <section id="instructor" className="relative overflow-hidden bg-[#1a1a2e] py-20 lg:py-28">
      {/* Glow accent */}
      <div className="pointer-events-none absolute -bottom-16 left-0 h-72 w-72 rounded-full bg-primary/10 blur-[90px]" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">

          {/* Photo column */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96, x: -30 }}
            whileInView={{ opacity: 1, scale: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative mx-auto w-full max-w-md"
          >
            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src={INSTRUCTOR.photo}
                alt={INSTRUCTOR.name}
                className="h-[500px] w-full object-cover object-top"
              />
              {/* Stats overlay */}
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <div className="grid grid-cols-3 gap-2">
                  {INSTRUCTOR.stats.map((s) => (
                    <div key={s.label} className="text-center">
                      <p className="font-display text-2xl font-bold text-primary">{s.value}</p>
                      <p className="text-[11px] leading-tight text-white/70">{s.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Bio column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="inline-block rounded-full bg-primary/20 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-primary">
              Instructor
            </span>
            <h2 className="section-title mt-4 text-white">
              {INSTRUCTOR.name}
            </h2>
            <p className="mt-2 text-sm font-semibold text-primary md:text-base">{INSTRUCTOR.role}</p>
            <p className="mt-1 text-sm font-medium text-white/70 md:text-base">
              Internationally Certified Career Coach, Founder of Change Ur Story
            </p>

            <p className="mt-6 text-base leading-relaxed text-white/70">{INSTRUCTOR.bio}</p>

            <div className="mt-8 grid grid-cols-2 gap-3">
              {INSTRUCTOR.credentials.map((c) => (
                <div key={c} className="flex items-center gap-2 text-sm text-white/80">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" />
                  {c}
                </div>
              ))}
            </div>

            <Button
              variant="hero"
              size="lg"
              className="mt-9 px-8"
              onClick={() => openEnroll("Professional")}
            >
              Try Chini Now
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
